<template>
  <div class="news">
    <template v-if="newsList.length > 0">
      <div class="news-list" v-for="item in newsList" :key="item.id">
        <div class="list-left" @click="goDetail(item.id)">
          <img src="@/assets/images/common/newslogo.png" alt="" />
          <div class="news-content">
            <h3>
              <span>{{ item.title }} </span> <i>{{ getTime(item.sendDate) }}</i>
            </h3>
            <p :title="item.msgAbstract">
              {{ item.msgAbstract }}
            </p>
          </div>
        </div>
        <div class="list-right">
          <img
            src="@/assets/images/common/close.png"
            alt=""
            @click="delNews(item.id)"
          />
        </div>
      </div>
    </template>
    <el-empty v-else description="暂无消息"></el-empty>
    <el-pagination
      v-if="newsList.length > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="100"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import util from "@/assets/util/util.js";
export default {
  name: "VirtualimitationIndex",

  data() {
    return {
      currentPage: 0,
      newsList: [],
      params: {
        pageIndex: 1,
        showItem: 10,
      },
      total: 0,
    };
  },

  mounted() {
    this.getNews();
  },

  methods: {
    //删除消息
    delNews(id) {
      this.$api.news.deleteNews([id]).then((res) => {
        if (res.errCode == 0) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getNews();
        }
      });
    },
    getTime(date) {
      return util.getTime(date);
    },
    getNews() {
      //只获取虚拟仿真平台的标签
      let params = {
        param: this.params,
        tagId: 5,
      };
      this.$api.news.getListByUser(params).then((res) => {
        if (res.errCode == 0 && res.data != null) {
          this.newsList = res.data.items;
          this.total = res.data.totalItems;
        }
      });
    },
    goDetail(id) {
      this.$router.push(`/newsDetail?id=${id}`);
    },
    handleSizeChange(val) {
      this.params.pageIndex = 1;
      this.params.showItem = val;
      this.getNews();
    },
    handleCurrentChange(val) {
      this.params.pageIndex = val;
      this.getNews();
    },
  },
};
</script>

<style lang="less" scoped>
.news {
  flex: 1;
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
  background: #fff;
  .news-list {
    width: 100%;
    height: 122px;
    padding: 24px 19px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #dfe3eb;
    .list-left {
      display: flex;
      justify-content: start;
      align-items: center;
      img {
        width: 63px;
        height: 63px;
      }
      .news-content {
        width: 1182px;
        margin-left: 18px;
        h3 {
          margin-bottom: 10px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          span {
            font-size: 16px;
            font-family: PingFang-SC;
            font-weight: 500;
            line-height: 22px;
            color: #101012;
            opacity: 1;
          }
          i {
            font-size: 12px;
            font-family: PingFang-SC;
            font-weight: 400;
            line-height: 17px;
            color: rgba(126, 126, 126, 0.6);
            opacity: 1;
            font-style: normal;
          }
        }
        p {
          width: 1182px;
          // display: -webkit-box;
          // -webkit-line-clamp: 2;
          // word-wrap: break-word;
          // -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #7e7e7e;
        }
      }
    }
    .list-right {
      img {
        cursor: pointer;
      }
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 16px;
  }
}
</style>